import {
  GET_PAYMENT_REQUEST_TRANSACTIONS_REQUEST,
  GET_PAYMENT_REQUEST_TRANSACTIONS_SUCCESS,
  GET_PAYMENT_REQUEST_TRANSACTIONS_FAILURE,
  RESET_PAYMENT_REQUEST_PAGINATION,
  CREATE_PAYMENT_REQUEST_REQUEST,
  CREATE_PAYMENT_REQUEST_SUCCESS,
  CREATE_PAYMENT_REQUEST_FAILURE,
  CREATE_DIRECT_PAYMENT_REQUEST_REQUEST,
  CREATE_DIRECT_PAYMENT_REQUEST_SUCCESS,
  CREATE_DIRECT_PAYMENT_REQUEST_FAILURE,
  MARK_PAYMENT_REQUEST_TRANSACTION_COMPLETED
} from 'Store/constants';

const initialState = {
  data: [],
  pagination: {
    page: 0,
    size: 20,
    totalElements: 0,
    totalPages: 0,
    first: true,
    last: true
  },
  isLoading: false,
  error: null,
  isFetched: false,
  isSubmitting: false,
  submitError: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PAYMENT_REQUEST_TRANSACTIONS_REQUEST:
      return { ...state, isLoading: true, error: null };

    case GET_PAYMENT_REQUEST_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        data: action.payload.page === 0
          ? (action.payload.content || [])
          : [...state.data, ...(action.payload.content || [])],
        pagination: {
          page: action.payload.page,
          size: action.payload.size,
          totalElements: action.payload.totalElements,
          totalPages: action.payload.totalPages,
          first: action.payload.first,
          last: action.payload.last
        },
        isLoading: false,
        error: null,
        isFetched: true
      };

    case GET_PAYMENT_REQUEST_TRANSACTIONS_FAILURE:
      return {
        ...state,
        pagination: initialState.pagination,
        isLoading: false,
        error: action.payload,
        isFetched: true
      };

    case RESET_PAYMENT_REQUEST_PAGINATION:
      return { ...state, pagination: initialState.pagination, data: [] };

    case CREATE_PAYMENT_REQUEST_REQUEST:
    case CREATE_DIRECT_PAYMENT_REQUEST_REQUEST:
      return { ...state, isSubmitting: true, submitError: null };

    case CREATE_PAYMENT_REQUEST_SUCCESS:
    case CREATE_DIRECT_PAYMENT_REQUEST_SUCCESS:
      return { ...state, isSubmitting: false, submitError: null };

    case CREATE_PAYMENT_REQUEST_FAILURE:
    case CREATE_DIRECT_PAYMENT_REQUEST_FAILURE:
      return { ...state, isSubmitting: false, submitError: action.payload };

    case MARK_PAYMENT_REQUEST_TRANSACTION_COMPLETED: {
      const normalizedLastTransactionId = action.payload?.toString?.();
      if (!normalizedLastTransactionId) {
        return state;
      }

      const nextData = state.data.map(transaction => {
        const transactionIdentifier = (
          transaction?.transactionId
          || transaction?.id
          || transaction?.paymentRequestId
          || transaction?.requestId
          || transaction?.lastTransactionId
        )?.toString?.();

        if (transactionIdentifier === normalizedLastTransactionId) {
          return {
            ...transaction,
            status: 'COMPLETED'
          };
        }
        return transaction;
      });

      const hasAnyUpdate = nextData.some((transaction, index) => transaction !== state.data[index]);
      if (!hasAnyUpdate) {
        return state;
      }

      return {
        ...state,
        data: nextData
      };
    }

    default:
      return state;
  }
};
